import Head from "next/head";

const CRITICAL_CSS = `
.outerContainer{
    width: 100%;
    border-radius: 15px;
    border: 1.5px solid #E6E6E6;
    margin-top: 10px;
}

.TitleDiv{
    padding: 10px 10px 10px 10px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    // background-color: #ffedee;
    // color: #EE3436;
    font-size: 26px;
    font-weight: 400;
    display: flex;
    align-items: 'center';
}

.Heading{
    font-size: 26px;
    font-weight: 400;
    color: #2E2E2E;
    margin: 0;
}

.rightArrow{    
    color: #EE3436;
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    @media screen and (max-width: 760px) {
        align-items: baseline;
    }
}

.SubHead{
    padding: 20px 10px 10px 6px;
}

.Content{
    font-size: 18px;
    font-weight: 700;
    color: #606060;
    margin: 0px 0px 0px 8px;
}
`;

const HighlightsCritical = () => (
  <Head>
    <style
      key="highlights-critical-css"
      dangerouslySetInnerHTML={{ __html: CRITICAL_CSS }}
    />
  </Head>
);

export default HighlightsCritical;
